import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateTimeFormat, TimeInterval } from 'types/EventState';
import { formatDateAndTimeIntervalOnTimeZone } from 'utils/events';
import CoverImage from './CoverImage';
import { Calendar, MapPin } from 'lucide-react';

interface TicketSaleCardHeaderProps {
  name: string;
  location: string;
  dateTimeFormat: DateTimeFormat;
  timeInterval: TimeInterval;
}

const TicketSaleCardHeader: React.FC<TicketSaleCardHeaderProps> = ({
  name,
  location,
  dateTimeFormat: { dateFormat, timeFormat, timezone },
  timeInterval: { startsAt, endsAt },
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="border-b border-neutral-40 p-[12px] sm:px-[24px] sm:py-[16px]"
      style={{ background: 'var(--cardTitleBackground)' }}
    >
      <CoverImage />
      {startsAt && endsAt ? (
        <div className="flex gap-2">
          <Calendar size={16} className="min-w-[20px] mt-[1px]" />
          <p className="p3-medium text-neutral-800">
            {formatDateAndTimeIntervalOnTimeZone(
              timezone,
              dateFormat,
              timeFormat,
              startsAt,
              endsAt,
              t('common.at'),
            )}
          </p>
        </div>
      ) : null}
      <div className="flex gap-2 mt-[4px]">
        <MapPin size={16} className="min-w-[20px] mt-[1px]" />
        <p className="p3-medium line-clamp-1 text-neutral-800">{location}</p>
      </div>
      <h2 className="title-md mt-[4px]">{name}</h2>
    </div>
  );
};

export default TicketSaleCardHeader;
